module.exports = __webpack_public_path__ + "static/media/dart.6775917e.svg";